var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Usuario_UnidadeActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Usuario_UnidadeModule = class Usuario_UnidadeModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Usuario_UnidadeActions.POST_USUARIO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.post("Usuario_Unidade/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Usuario_UnidadeActions.POSTRANGEBACK_USUARIO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.post("Usuario_Unidade/PostRangeBack", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Usuario_UnidadeActions.PUT_USUARIO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.put("Usuario_Unidade/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Usuario_UnidadeActions.DELETE_USUARIO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.delete("Usuario_Unidade/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Usuario_UnidadeActions.DELETE_RANGE_USUARIO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.delete("Usuario_Unidade/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Usuario_UnidadeActions.FILTER_USUARIO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.post("Usuario_Unidade/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Usuario_UnidadeActions.GET_USUARIO_UNIDADE]() {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Usuario_UnidadeActions.GET_BY_USUARIO_ID_USUARIO_UNIDADE]() {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade/GetByUsuarioId")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Usuario_UnidadeActions.GET_UNIDADE_BY_USUARIO_ID]() {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade/GetUnidadeByUsuarioId")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Usuario_UnidadeActions.GETUNITBYUSER_USUARIO_UNIDADE]() {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade/GetUnitByUser")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_l = Usuario_UnidadeActions.GETWITHDISABLED_USUARIO_UNIDADE]() {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_m = Usuario_UnidadeActions.GET_BY_ID_USUARIO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _l, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_UnidadeModule.prototype, _m, null);
Usuario_UnidadeModule = __decorate([
    Module
], Usuario_UnidadeModule);
export default Usuario_UnidadeModule;
//# sourceMappingURL=Usuario_UnidadeModule.js.map